import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import ExecutedTable from "../components/Orders/Executedtable";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersData } from "../store/Slice/OrdersSlice";
import ExecutuedTable from "../components/Orders/Executedtable";
const Orders = () => {
  const [activeKey, setActiveKey] = useState("1");
  const { userId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const renderTable = () => {
    if (activeKey === "1") {
      // Render Table 1 here
      return <ExecutuedTable />;
    } else if (activeKey === "2") {
      // Render Table 2 here
      return <ExecutedTable />;
    }
    // Add more conditions for additional tabs if needed
  };

  const getOrders = () => {
    dispatch(getOrdersData(userId));
  };
  useEffect(() => {
    getOrders();
  }, []);

  return (
    <div className="w-full">
      <Tabs
        defaultActiveKey="1"
        onChange={handleTabChange}
        className="ml-10"
        tabBarStyle={{
          color: '#939393',
          fontSize: '1.1rem'
        }}
      >
        {["Open", "Executed", "GTT"].map((Icon, i) => {
          const id = String(i + 1);
          return (
            <TabPane key={id} tab={<span className="text-[#939393] text-lg">{Icon}</span>}>
              {renderTable()}
            </TabPane>
          );
        })}
      </Tabs>
    </div>
  );
};

export default Orders;
